<template>
  <div id="admin-sidebox" style="min-width: 30rem; max-width: 30rem">
    <ul class="nav nav-tabs gap-1" style="margin: 0 0 -1px 0.5rem">
      <li v-if="resourceCollection?.data" class="nav-item">
        <button
          :class="currentFocus === 'resources' ? 'active' : 'text-muted'"
          class="nav-link"
          @click="setFocus('resources')"
        >
          Ressourcen
        </button>
      </li>
      <li class="nav-item">
        <button :class="currentFocus === 'log' ? 'active' : 'text-muted'" class="nav-link" @click="setFocus('log')">
          Logbuch
        </button>
      </li>
    </ul>
    <div v-if="resourceCollection?.data && currentFocus === 'resources'" class="card">
      <div class="card-body resources-list position-relative">
        <resource-collection
          :collection-type="resource.meta.config.component?.type ?? 'list'"
          :meta="resource.meta"
          :mode="'dashboard'"
          :models="resourceCollection"
          :pagination="false"
        ></resource-collection>
      </div>
    </div>
    <template v-if="currentFocus === 'log'">
      <app-event-log :log-entries="resource.logEntries" :meta="meta" :resource-type="resourceType"></app-event-log>
    </template>
  </div>
</template>

<script>
import AppEventLog from '@kanrisha/components/AppEventLog/AppEventLog';
import useResource from '@kanrisha/composables/useResource';
import { ref } from 'vue';
import ResourceCollection from '@kanrisha/components/ResourceCollection';

export default {
  components: { ResourceCollection, AppEventLog },
  props: {
    resource: { type: Object, default: () => {} },
    resourceCollection: { type: Object, default: () => {} },
    focus: { type: String, default: null },
  },
  emit: [],
  setup(props) {
    const currentFocus = ref(props.focus ?? 'log');
    const { meta, resourceType } = useResource(props, props.resource);

    const setFocus = (name) => {
      currentFocus.value = name;
    };

    return {
      currentFocus,
      meta,
      resourceType,
      setFocus,
    };
  },
};
</script>
